var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIcon2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4999 64.4051C50.5683 64.4051 64.405 50.5684 64.405 33.5C64.405 16.4316 50.5683 2.59497 33.4999 2.59497C16.4315 2.59497 2.59485 16.4316 2.59485 33.5C2.59485 50.5684 16.4315 64.4051 33.4999 64.4051Z",
    fill: "#21AA47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 67C15.0296 67 0 51.973 0 33.5C0 15.0296 15.0296 0 33.5 0C51.973 0 67 15.0296 67 33.5C67 51.973 51.973 67 33.5 67ZM33.5 5.18975C17.8891 5.18975 5.18975 17.8891 5.18975 33.5C5.18975 49.1109 17.8891 61.8102 33.5 61.8102C49.1109 61.8102 61.8102 49.1083 61.8102 33.5C61.8102 17.8891 49.1109 5.18975 33.5 5.18975Z",
    fill: "#21AA47"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1698 45.6495C28.4744 45.6495 27.8101 45.3718 27.3196 44.8736L17.7445 35.1428C16.7403 34.1204 16.7532 32.4804 17.7756 31.4736C18.798 30.472 20.4406 30.4823 21.4448 31.5047L29.0946 39.279L44.9209 21.8492C45.8887 20.7879 47.5287 20.7126 48.5848 21.6728C49.6461 22.6355 49.7239 24.2754 48.7612 25.3393L31.0901 44.8008C30.6101 45.3302 29.9354 45.6364 29.2218 45.6519C29.2036 45.6495 29.188 45.6495 29.1698 45.6495Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 13,
    y: 21,
    width: 40.435,
    height: 32.6519,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon2);
export default __webpack_public_path__ + "static/media/successIcon2.add7f89f2fa08000a070fd6f830df80b.svg";
export { ForwardRef as ReactComponent };